var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("q-form", { ref: "editForm" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
            },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "산업보건 일지 기본정보" },
                },
                [
                  _c(
                    "template",
                    { slot: "card-button" },
                    [
                      _c(
                        "q-btn-group",
                        { attrs: { outline: "" } },
                        [
                          _c("c-appr-btn", {
                            ref: "appr-btn",
                            attrs: {
                              name: "appr-btn",
                              editable: _vm.editable,
                              approvalInfo: _vm.approvalInfo,
                            },
                            on: {
                              beforeApprAction: _vm.approvalJournal,
                              callbackApprAction: _vm.approvalJournalCallback,
                              requestAfterAction: _vm.getDetail,
                            },
                          }),
                          _vm.isOld && _vm.editable && !_vm.disabled
                            ? _c("c-btn", {
                                attrs: {
                                  label: "LBLREMOVE",
                                  icon: "delete_forever",
                                },
                                on: { btnClicked: _vm.remove },
                              })
                            : _vm._e(),
                          _c("c-btn", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.editable && !_vm.disabled,
                                expression: "editable && !disabled",
                              },
                            ],
                            attrs: {
                              url: _vm.saveUrl,
                              isSubmit: _vm.isSave,
                              param: _vm.journal,
                              mappingType: _vm.saveType,
                              label: "LBLSAVE",
                              icon: "save",
                            },
                            on: {
                              beforeAction: _vm.savePlan,
                              btnCallback: _vm.saveCallback,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-plant", {
                          attrs: {
                            required: "",
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            type: "edit",
                            name: "plantCd",
                          },
                          model: {
                            value: _vm.journal.plantCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.journal, "plantCd", $$v)
                            },
                            expression: "journal.plantCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-datepicker", {
                          attrs: {
                            required: "",
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            label: "작성일",
                            type: "date",
                            name: "startDate",
                          },
                          model: {
                            value: _vm.journal.startDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.journal, "startDate", $$v)
                            },
                            expression: "journal.startDate",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            required: "",
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            label: "일지명",
                            name: "journalName",
                          },
                          model: {
                            value: _vm.journal.journalName,
                            callback: function ($$v) {
                              _vm.$set(_vm.journal, "journalName", $$v)
                            },
                            expression: "journal.journalName",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
            },
            [
              _c("c-table", {
                ref: "totalGrid",
                attrs: {
                  title: "전체 지급 현황",
                  columns: _vm.totalGrid.columns,
                  gridHeight: _vm.totalGrid.height,
                  data: _vm.totalGrid.data,
                  gridHeightAuto: true,
                  filtering: false,
                  columnSetting: false,
                  usePaging: false,
                  hideBottom: true,
                  editable: _vm.editable,
                },
                scopedSlots: _vm._u([
                  {
                    key: "customArea",
                    fn: function ({ props, col }) {
                      return [
                        props.row[col.name] > 0
                          ? [_vm._v(" " + _vm._s(props.row[col.name]) + " ")]
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
            },
            [
              _c(
                "c-table",
                {
                  ref: "grid",
                  attrs: {
                    title: "의약품&의약외품 지급 현황",
                    columns: _vm.grid.columns,
                    gridHeight: _vm.grid.height,
                    data: _vm.journal.results,
                    filtering: false,
                    columnSetting: false,
                    usePaging: false,
                    hideBottom: true,
                    editable: _vm.editable && !_vm.disabled,
                    rowKey: "industryHealthJournalItemId",
                    selection: "multiple",
                  },
                },
                [
                  _c(
                    "template",
                    { slot: "table-button" },
                    [
                      _c(
                        "q-btn-group",
                        { attrs: { outline: "" } },
                        [
                          _vm.editable && !_vm.disabled
                            ? _c("c-btn", {
                                attrs: {
                                  showLoading: false,
                                  label: "LBLADD",
                                  icon: "add",
                                },
                                on: { btnClicked: _vm.addResult },
                              })
                            : _vm._e(),
                          _vm.editable &&
                          !_vm.disabled &&
                          _vm.journal.results.length > 0
                            ? _c("c-btn", {
                                attrs: {
                                  showLoading: false,
                                  label: "LBLEXCEPT",
                                  icon: "remove",
                                },
                                on: { btnClicked: _vm.removeResult },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
            },
            [
              _c(
                "c-table",
                {
                  ref: "grid2",
                  attrs: {
                    title: "물리치료&외상처리 현황",
                    columns: _vm.grid2.columns,
                    gridHeight: _vm.grid2.height,
                    data: _vm.journal.statuses,
                    filtering: false,
                    columnSetting: false,
                    usePaging: false,
                    hideBottom: true,
                    editable: _vm.editable && !_vm.disabled,
                    rowKey: "industryHealthJournalStatusId",
                    selection: "multiple",
                  },
                },
                [
                  _c(
                    "template",
                    { slot: "table-button" },
                    [
                      _c(
                        "q-btn-group",
                        { attrs: { outline: "" } },
                        [
                          _vm.editable && !_vm.disabled
                            ? _c("c-btn", {
                                attrs: {
                                  showLoading: false,
                                  label: "LBLADD",
                                  icon: "add",
                                },
                                on: { btnClicked: _vm.addResult2 },
                              })
                            : _vm._e(),
                          _vm.editable &&
                          !_vm.disabled &&
                          _vm.journal.statuses.length > 0
                            ? _c("c-btn", {
                                attrs: {
                                  showLoading: false,
                                  label: "LBLEXCEPT",
                                  icon: "remove",
                                },
                                on: { btnClicked: _vm.removeResult2 },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ]),
      ]),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }